import { Blockthrough_Vendor } from "@/config/reach/common/constants/consent";
import type { BlockthroughModule } from "@/ts/module";
import { appendHtmlToHead } from "@/utils/dom";
import { getModules } from "@/utils/modules";
import { blockthroughTag } from "@/vendors/blockthroughTag";

export class Blockthrough implements BlockthroughModule {
	name = "Blockthrough" as const;

	async init(): Promise<void> {
		const [consentModule] = await getModules(["Consent"]);
		const consented = await consentModule.run({
			vendorId: Blockthrough_Vendor,
		});
		if (consented) {
			appendHtmlToHead(blockthroughTag);
		}
	}
}
